export default [
    function () {
        return {
            restrict: 'EA',
            scope: {
                message: '=eeeMessage',
            },
            template: `
                <i
                    class="material-icons md-dark md-14 {{message.state}}"
                    title="{{ message | messageStateTitleText | translate }}"
                    aria-label="icon {{ message | messageStateTitleText | translate }}"
                >{{ message | messageStateIcon }}</i>
            `,
        };
    },
];
